import { render } from "./info-agent.vue?vue&type=template&id=055ea962"
import script from "./info-agent.vue?vue&type=script&lang=js"
export * from "./info-agent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-form/info-agent.vue'],['render',render],['__file',"info-agent.vue"]])

export default __exports__